import apiFetch from 'utils/apiFetch';
import { loadingAction } from 'store/globalState/global';
import history from 'store/history';
import * as ACTION_TYPE from './types';

export function getMyThinkTanks() {
  return (dispatch) => {
    dispatch(loadingAction(true));

    dispatch({
      type: ACTION_TYPE.GET_MY_THINK_TANKS_DATA_INIT,
    });

    apiFetch('GET', { endPoint: 'think-tanks/me' }, {})
      .then((data) => {
        dispatch({
          type: ACTION_TYPE.GET_MY_THINK_TANKS_DATA_SUCCESS,
          payload: {
            data,
          },
        });
        dispatch(loadingAction(false));
      })
      .catch(() => {
        dispatch({
          type: ACTION_TYPE.GET_MY_THINK_TANKS_DATA_FAILURE,
        });
        dispatch(loadingAction(false));
      });
  };
}

export function getThinkTank(id) {
  return (dispatch) => {
    dispatch(loadingAction(true));

    dispatch({
      type: ACTION_TYPE.GET_THINK_TANK_DATA_INIT,
    });

    apiFetch('GET', { endPoint: `think-tanks/${id}` }, {})
      .then((data) => {
        dispatch({
          type: ACTION_TYPE.GET_THINK_TANK_DATA_SUCCESS,
          payload: {
            data,
          },
        });
        dispatch(loadingAction(false));
      })
      .catch(() => {
        dispatch({
          type: ACTION_TYPE.GET_THINK_TANK_DATA_FAILURE,
        });
        dispatch(loadingAction(false));
      });
  };
}

export function changeThinkTankImage(id, image) {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPE.CHANGE_THINK_TANK_IMAGE_INIT,
      payload: {
        data: image,
      },
    });

    apiFetch('POST', { endPoint: `think-tanks/${id}/image` }, { image })
      .then((data) => {
        dispatch({
          type: ACTION_TYPE.CHANGE_THINK_TANK_IMAGE_SUCCESS,
          payload: {
            data,
          },
        });
      })
      .catch(() => {
        dispatch({
          type: ACTION_TYPE.CHANGE_THINK_TANK_IMAGE_FAILURE,
        });
      });
  };
}

export function getThinkTankTools(id) {
  return (dispatch) => {
    dispatch(loadingAction(true));

    dispatch({
      type: ACTION_TYPE.GET_THINK_TANK_TOOLS_INIT,
    });

    apiFetch('GET', { endPoint: `think-tanks/${id}/tools` }, {})
      .then((data) => {
        dispatch({
          type: ACTION_TYPE.GET_THINK_TANK_TOOLS_SUCCESS,
          payload: {
            data,
          },
        });
        dispatch(loadingAction(false));
      })
      .catch(() => {
        dispatch({
          type: ACTION_TYPE.GET_THINK_TANK_TOOLS_FAILURE,
        });
        dispatch(loadingAction(false));
      });
  };
}

export function requestJoin(id) {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPE.REQUEST_THINK_TANK_INIT,
    });

    apiFetch('POST', { endPoint: `think-tanks/${id}/request_join` })
      .then((data) => {
        dispatch({
          type: ACTION_TYPE.REQUEST_THINK_TANK_SUCCESS,
          payload: {
            data,
          },
        });
      })
      .catch((data) => {
        dispatch({
          type: ACTION_TYPE.REQUEST_THINK_TANK_FAILURE,
          payload: {
            data: data.response.data,
          },
        });
      });
  };
}

export function acceptJoin(id, requestId) {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPE.REQUEST_ACCEPT_THINK_TANK_INIT,
    });

    apiFetch('POST', { endPoint: `think-tanks/${id}/requests_join/${requestId}/accept` })
      .then((data) => {
        dispatch({
          type: ACTION_TYPE.REQUEST_ACCEPT_THINK_TANK_SUCCESS,
          payload: {
            response: data,
            id: requestId,
          },
        });
      })
      .catch((data) => {
        dispatch({
          type: ACTION_TYPE.REQUEST_ACCEPT_THINK_TANK_FAILURE,
          payload: {
            data: data.response.data,
          },
        });
      });
  };
}

export function rejectJoin(id, requestId) {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPE.REQUEST_REJECT_THINK_TANK_INIT,
    });

    apiFetch('POST', { endPoint: `think-tanks/${id}/requests_join/${requestId}/reject` })
      .then((data) => {
        dispatch({
          type: ACTION_TYPE.REQUEST_REJECT_THINK_TANK_SUCCESS,
          payload: {
            response: data,
            id: requestId,
          },
        });
      })
      .catch((data) => {
        dispatch({
          type: ACTION_TYPE.REQUEST_REJECT_THINK_TANK_FAILURE,
          payload: {
            data: data.response.data,
          },
        });
      });
  };
}

export function getRequestsJoin(id) {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPE.GET_REQUESTS_THINK_TANK_INIT,
    });

    apiFetch('GET', { endPoint: `think-tanks/${id}/requests_join` })
      .then((data) => {
        dispatch({
          type: ACTION_TYPE.GET_REQUESTS_THINK_TANK_SUCCESS,
          payload: {
            data: data.data,
          },
        });
      })
      .catch((data) => {
        dispatch({
          type: ACTION_TYPE.GET_REQUESTS_THINK_TANK_FAILURE,
          payload: {
            data: data.response.data,
          },
        });
      });
  };
}

export function getAllRequestsJoin() {
  return (dispatch) => {
    dispatch({
      type: ACTION_TYPE.GET_REQUESTS_THINK_TANK_INIT,
    });

    apiFetch('GET', { endPoint: 'think-tanks/requests_join' })
      .then((data) => {
        dispatch({
          type: ACTION_TYPE.GET_REQUESTS_THINK_TANK_SUCCESS,
          payload: {
            data: data.data,
          },
        });
      })
      .catch((data) => {
        dispatch({
          type: ACTION_TYPE.GET_REQUESTS_THINK_TANK_FAILURE,
          payload: {
            data: data.response.data,
          },
        });
      });
  };
}

export function leaveThinkTank(id) {
  return (dispatch) => {
    dispatch(loadingAction(true));
    dispatch({
      type: ACTION_TYPE.LEAVE_THINK_TANK_INIT,
    });

    apiFetch('POST', { endPoint: `think-tanks/${id}/leave` })
      .then((data) => {
        dispatch({
          type: ACTION_TYPE.LEAVE_THINK_TANK_SUCCESS,
          payload: {
            response: data,
            id,
          },
        });
        dispatch(loadingAction(false));
        history.push('/think');
      })

      .catch((data) => {
        dispatch({
          type: ACTION_TYPE.LEAVE_THINK_TANK_FAILURE,
          payload: {
            data: data.response.data,
          },
        });
      });
  };
}

export const getAdditionalThinks = () => {
  return (dispatch) => {
    dispatch(loadingAction(true));
    dispatch({
      type: ACTION_TYPE.GET_ADDITIONAL_THINKS_INIT,
    });

    apiFetch('GET', { endPoint: 'theme-table/thinks' })
      .then((data) => {
        dispatch({
          type: ACTION_TYPE.GET_ADDITIONAL_THINKS_SUCCESS,
          payload: {
            data,
          },
        });
        dispatch(loadingAction(false));
      })
      .catch(() => {
        dispatch({
          type: ACTION_TYPE.GET_ADDITIONAL_THINKS_FAILURE,
        });
      });
  };
};

export const launchThinkTank = ({
  id, name, description, members, socialNetworkMovement, blog, project, openInnovation,
}) => (dispatch) => {
  dispatch(loadingAction(true));
  return apiFetch('POST', { endPoint: `think-seed/${id}/launch` },
    {
      name,
      description,
      members,
      social_network_movement: socialNetworkMovement,
      blog,
      project,
      open_innovation: openInnovation,
    }).then((data) => {
    dispatch({
      type: ACTION_TYPE.ADD_ADDITIONAL_THINK_TANK,
      payload: {
        data,
      },
    });
    dispatch(loadingAction(false));
  });
};

export const proposeContent = (params) => {
  return (dispatch) => {
    return apiFetch('POST', { endPoint: `theme-table/${params.related_id}/content` }, params);
  };
};

export const getProposedContent = (id) => {
  const params = {
    id,
  };
  return (dispatch) => {
    apiFetch('GET', { endPoint: `theme-table/${id}/content` }, params)
      .then((data) => {
        dispatch({
          type: ACTION_TYPE.GET_PROPOSED_CONTENT_SUCCESS,
          payload: {
            data,
          },
        });
      })
      .catch(() => {
        dispatch({
          type: ACTION_TYPE.GET_PROPOSED_CONTENT_FAILURE,
        });
      });
  };
};

export const getAllProposedContent = () => {
  return (dispatch) => {
    apiFetch('GET', { endPoint: 'content' })
      .then((data) => {
        dispatch({
          type: ACTION_TYPE.GET_ALL_PROPOSED_CONTENT_SUCCESS,
          payload: {
            data,
          },
        });
      })
      .catch(() => {
        dispatch({
          type: ACTION_TYPE.GET_ALL_PROPOSED_CONTENT_FAILURE,
        });
      });
  };
};

export const deleteProposedContent = (id, userId) => {
  const params = {
    id,
    user_id: userId,
  };
  return apiFetch('delete', { endPoint: `theme-table/content/${id}` }, params);
};

export const launchTable = (id, userId) => {
  const params = {
    id,
    user_id: userId,
  };
  return apiFetch('POST', { endPoint: `theme-table/${id}/launch` }, params);
};



// WEBPACK FOOTER //
// ./src/components/ThinkTanks/modules/actions.js